import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/coinbase_wallet.svg'
import _imports_1 from '@/assets/images/wallet_connect.svg'


const _hoisted_1 = {
  key: 0,
  class: "bad-configuration"
}
const _hoisted_2 = {
  key: 1,
  class: "m-connection-container"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Disconnect ")
const _hoisted_4 = {
  key: 2,
  class: "m-connection-wrong-network",
  disabled: ""
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["disabled", "onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "m-connection-wallet-logo",
  src: _imports_0
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Coinbase Wallet ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "m-connection-wallet-logo",
  src: _imports_1
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Wallet Connect ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "m-connection",
    class: _normalizeClass({ connected: _ctx.walletConnected })
  }, [
    (_ctx.badConfiguration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", null, _toDisplayString(_ctx.badConfiguration), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.walletConnected && (!_ctx.injectedWallet || !_ctx.wrongChain))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "m-connection-disconnect-wallet",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.disconnectAndClose && _ctx.disconnectAndClose(...args)))
              }, [
                _hoisted_3,
                _createElementVNode("span", {
                  class: "m-connection-wallet",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showConnectOptions = !_ctx.showConnectOptions))
                }, _toDisplayString(_ctx.walletENS ? _ctx.walletENS : _ctx.walletAddressShort), 1)
              ]))
            : (_ctx.walletConnected && _ctx.wrongChain && _ctx.enableNetworkSwitching)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "m-connection-switch-network",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.switchNetwork && _ctx.switchNetwork(...args)))
                }, " Switch network "))
              : (_ctx.walletConnected && _ctx.wrongChain)
                ? (_openBlock(), _createElementBlock("button", _hoisted_4, " Wrong network "))
                : (!_ctx.showConnectOptions && (!_ctx.alwaysOpen || _ctx.isLoading))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      disabled: _ctx.isLoading,
                      class: "m-connection-connect-wallet",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setShowConnectOptions && _ctx.setShowConnectOptions(...args)))
                    }, [
                      _createElementVNode("span", { innerHTML: _ctx.buttonText }, null, 8, _hoisted_6)
                    ], 8, _hoisted_5))
                  : _createCommentVNode("", true)
        ])),
    ((_ctx.showConnectOptions || _ctx.alwaysOpen) && !_ctx.walletConnected && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "m-connection-wallet-options",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeConnectOptions && _ctx.closeConnectOptions(...args)))
        }, [
          (_ctx.browserWallets.length >= 1)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.browserWallets, (wallet) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: wallet.name,
                  class: _normalizeClass('m-connection-wallet-option ' + wallet.name.replaceAll(' ', '').toLowerCase()),
                  disabled: _ctx.isLoading,
                  onClick: ($event: any) => (_ctx.connectBrowserWallet(wallet.name, wallet.provider!))
                }, [
                  (wallet.logo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "m-connection-wallet-logo",
                        src: wallet.logo
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(wallet.name), 1)
                ], 10, _hoisted_7))
              }), 128))
            : _createCommentVNode("", true),
          (
          !_ctx.browserWallets.map((w) => w.name).includes('Coinbase Wallet') &&
          !_ctx.walletsHidden.has('coinbase wallet')
        )
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "m-connection-wallet-option coinbase",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.connectCoinbaseWallet && _ctx.connectCoinbaseWallet(...args)))
              }, _hoisted_11))
            : _createCommentVNode("", true),
          (
          (_ctx.walletConnectProjectId || _ctx.detectedApp?.walletConnectProjectId) &&
          !_ctx.walletsHidden.has('wallet connect')
        )
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "m-connection-wallet-option walletconnect",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.connectWalletConnect && _ctx.connectWalletConnect(...args)))
              }, _hoisted_14))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}